import React from 'react'

import SelectProjectMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/project-multi"
import FormManager from "../../../gd-form/common/form-manager"
import CustomView from "../../../model2/custom-view/custom-view"
import SelectOptionMulti
    from "../../../../app/quick-add/sections/view/components/forms/common-blocks/select-option-multi"
import {EntityType} from "../../../gd/const/item"

type PrioritiesConditionsType = {
    projects    : ID[]
    items       : {
        projects    : boolean
        tasks       : boolean
    }
    priorities  : number[]
}

type Props = {
    className?  : string

    view        : CustomView
    disabled?   : boolean
    onChange    : { (conditions: PrioritiesConditionsType):void }
}

// const debug = "ViewPriorities_Conditions"
const debug = false

export default function ViewPriorities_Conditions(props: Props) {

    debug && console.log(debug, 'render', props)

    const onUserChange = () => {
        debug && console.log(debug, 'onUserChange')

        const result = form.getValues()

        const items = {
            projects    : result.items.includes('projects'),
            tasks       : result.items.includes('tasks'),
        }

        const conditions: PrioritiesConditionsType = {
            projects    : result.projects,
            items       : items,
            priorities  : result.priorities,
        }

        debug && console.log(debug, 'onUserChange conditions', conditions)

        props.onChange(conditions)
    }

    const onParentSelect = (projects: ID[]) => {
        debug && console.log(debug, 'onParentSelect')

        form.onFormComponentValueChange('projects', projects)

        onUserChange()
    }

    const conditions = props.view.settings

    const items: string[] = []
    if (conditions?.items?.projects) items.push('projects')
    if (conditions?.items?.tasks) items.push('tasks')

    const initFormData: any = {
        projects    : conditions?.projects || [],
        items       : !_.isEmpty(items) ? items : ['projects', 'tasks'],
        priorities  : conditions?.priorities || gd.company.priorities.exportToOptions().map((p: any) => p.value).filter((v: number) => v > 5)
    }

    const formStructure = {
        fields          : {
            projects        : { type: 'select',   isRequired: false,  label: 'Projects'},
            items           : { type: 'select',   isRequired: false,  label: 'View type',           onUserChange: onUserChange,
                validator: (val:any) => {
                    return val.length > 0 ? true : 'At least one type should be selected'
                }
            },
            priorities      : { type: 'select',   isRequired: false,  label: 'Minimum priorities',  onUserChange: onUserChange,}
        },
        isFormChanged   : true,
    }

    const form = new FormManager(formStructure, initFormData)

    const classes = Classes("ui5-form", props.className)

    const itemsOptions = [
        { value: 'projects',    label: 'Projects',  icon: '' },
        { value: 'tasks',       label: 'Tasks',     icon: '' },
    ]

    const prioritiesOptions = gd.session.companies.get(gd.companyId).priorities.exportToOptions()

    return (
        <div className={classes}>
            <div className="tbl">
                <SelectProjectMulti form            = {form}
                                    formFieldName   = 'projects'
                                    parentsFor      = {EntityType.PROJECT}
                                    disabled        = {props.disabled}
                                    onParentSelect  = {onParentSelect}/>

                <SelectOptionMulti label         = "View items"
                                   form          = {form}
                                   formFieldName = 'items'
                                   options       = {itemsOptions}
                                   disabled      = {props.disabled}/>

                <SelectOptionMulti label         = "Priorities"
                                   form          = {form}
                                   formFieldName = 'priorities'
                                   options       = {prioritiesOptions}
                                   disabled      = {props.disabled}/>
            </div>
        </div>
    )
}